import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {appInjector} from "../../appInjector";
import {throttle} from "rxjs/operators";
import {interval, timer} from "rxjs";
import {CalculateInputsService} from "@src/app/services/calculateInputsService/calculate-inputs.service";


export class CalculationPlugin extends AbstractMainPlugin {

  protected calculateInputService: CalculateInputsService;

  constructor(item:Item) {
    super(item);

    this.calculateInputService = appInjector.get(CalculateInputsService);

    item.config.subject
      .pipe(throttle(config => interval(1000), {trailing: true}))
      .subscribe((config) => {
        this.calculateInputService.calculateItemInputs(item);
      });
  }
}
